export const unitOptions = [
  { id: 'index', label: 'Index' },
  { id: '$/day', label: '$/day' },
  { id: '$/tonne', label: '$/tonne' }
];

export const frequencyOptions = [
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'quarterly', label: 'Quarterly' }
];
